//#region src/variants/variants_checkbox.js
var variants_checkbox_default = {
	defaults: { props: { labelSize: { tokenCategory: "typography-size:label" } } },
	default: { props: { label: { initialValue: "Checkbox label" } } },
	"with description": { props: {
		label: { initialValue: "Block callers not already in contacts list" },
		description: { initialValue: "You get enough calls. Free up some of your time." }
	} },
	"with validation": { props: {
		label: { initialValue: "Block callers not already in contacts list" },
		validationState: { initialValue: "warning" },
		messages: { initialValue: [{
			message: "Select how phone numbers you dont know should be handled.",
			type: "warning"
		}] }
	} }
};
//#endregion
export { variants_checkbox_default as default };

//# sourceMappingURL=variants_checkbox.js.map